import { useRef } from "react";
import {useScrollPositionPersist} from "../../../../modules/persist/useScrollPositionPersist";
import type { MutableRefObject } from "react";
import { useParams } from "react-router-dom";

export interface ISongResultsScrollableContentLogic {
  scrollableContentRef: MutableRefObject<HTMLElement>;
  onScrollHandler: () => void;
}

export const useSongResultsScrollableContentLogic = (): ISongResultsScrollableContentLogic => {
  const scrollableContentRef = useRef<HTMLElement>(document.createElement('main'));
  const {resultsPage, libraryFilterSubset} = useParams<{resultsPage?: string; libraryFilterSubset?: string; }>();
  const scrollPositionKey = `songs:${resultsPage ?? `home`}:${libraryFilterSubset ?? `all`}`;
  const {onScrollHandler} = useScrollPositionPersist<HTMLElement>(scrollPositionKey, scrollableContentRef);

  return {
    scrollableContentRef,
    onScrollHandler,
  };
}
